import { Controller } from "@hotwired/stimulus";
import { flashAlert } from "../../components/flash_alert";

export default class extends Controller {
  static targets = [];

  validated(event) {
    const { message, sales_invoices } = event.detail[0];
    flashAlert(message);
    document.dispatchEvent(new CustomEvent("salesInvoices:validated", { detail: sales_invoices }));
  }
}
